
import { Component, Prop, Vue } from 'vue-property-decorator';

interface Subcategory {
    name: string;
    subcategories?: Subcategory[];
}

@Component
export default class SubcategoryItem extends Vue {
    @Prop({ required: true }) readonly subcategories!: Subcategory[];
    isOpen: boolean[] = [];

    toggle(index: number) {
        // Переключаем состояние только для текущего элемента
        this.$set(this.isOpen, index, !this.isOpen[index]);
    }
}
